import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Drawer,
    List,
    ListItem,
    ListItemText,
    Collapse,
    IconButton
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import MenuItems from './MenuItems';
import { useTranslation } from "react-i18next";
import { showHidden } from "Components/API"; // Assuming showHidden is imported correctly

const NavbarMobile = () => {
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState([]);
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const toggleDrawer = () => {
        setDrawerOpen(!isDrawerOpen);
        setSubMenuOpen([]);
    };

    const toggleSubMenu = (index) => {
        const updatedOpenState = [...subMenuOpen];
        updatedOpenState[index] = !updatedOpenState[index];
        setSubMenuOpen(updatedOpenState);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
        setSubMenuOpen([]);
    };

    const renderSubMenu = (menuItem, index) => {
        const shouldRender =
            (!menuItem.showOnlyinFA || currentLang === "fa") &&
            (!menuItem.hideInDemo || !showHidden) &&
            (showHidden || !menuItem.showInDemo);

        if (shouldRender) {
            if (menuItem.hasSubMenu) {
                return (
                    <React.Fragment key={index}>
                        <ListItem button onClick={() => toggleSubMenu(index)}>
                            <ListItemText primary={t(menuItem.label)} />
                            {subMenuOpen[index] ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={subMenuOpen[index]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {menuItem.submenu.map((submenuItem, submenuIndex) => {
                                    const shouldRenderSubmenu =
                                        (!submenuItem.showOnlyinFA || currentLang === "fa") &&
                                        (!submenuItem.hideInDemo || !showHidden) &&
                                        (showHidden || !submenuItem.showInDemo);

                                    return (
                                        shouldRenderSubmenu && (
                                            <a
                                                href={submenuItem.link}
                                                key={submenuIndex}
                                                onClick={closeDrawer}
                                                {...submenuItem.link.includes("http")
                                                    ? { target: "_blank", rel: "noopener noreferrer" }
                                                    : {}}
                                            >
                                                <ListItem button>
                                                    <ListItemText primary={t(submenuItem.label)} />
                                                </ListItem>
                                            </a>
                                        )
                                    );
                                })}
                            </List>
                        </Collapse>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={index}>
                        <Link to={menuItem.link} onClick={closeDrawer}>
                            <ListItem button>
                                <ListItemText
                                    primary={
                                        <>
                                            {t(menuItem.label)}{' '}
                                            {menuItem.comingSoon && (
                                                <span className="coming-soon">
                                                    {t('progress')}
                                                </span>
                                            )}
                                        </>
                                    }
                                />
                            </ListItem>
                        </Link>
                    </React.Fragment>
                );
            }
        }
        return null;
    };

    return (
        <>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                edge="start"
                className="navbar-toggler"
                style={{ marginTop:"4px"} }
            >
                {isDrawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>

            <Drawer className="navbarMobile" anchor="right" open={isDrawerOpen} onClose={toggleDrawer}>
                <List>
                    {MenuItems.map((menuItem, index) => renderSubMenu(menuItem, index))}
                </List>
            </Drawer>
        </>
    );
};

export default NavbarMobile